import { useState, useEffect, useRef } from "react";
import { Receipt, Save } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import api from "@/lib/api";

const FIELDS = [["name", "Business name"], ["email", "Email"], ["phone", "Phone"], ["website", "Website"], ["address", "Address"]];

export const InvoiceSettingsCard = () => {
  const [f, setF] = useState(null);
  const [failed, setFailed] = useState(false);
  const loaded = useRef(false);
  useEffect(() => { api.get("/api/admin/invoice-settings").then(r => { if (!loaded.current) { loaded.current = true; setF(r.data); } }).catch(() => setFailed(true)); }, []);
  const save = async () => {
    try { const { data } = await api.put("/api/admin/invoice-settings", f); setF(data); toast.success("Invoice details saved"); }
    catch (err) { toast.error(err.response?.data?.detail?.[0]?.msg || err.response?.data?.detail || "Save failed"); }
  };
  if (failed) return <p className="text-sm text-red-600 mt-6" data-testid="invoice-settings-error">Couldn't load invoice details — refresh to try again.</p>;
  if (!f) return null;
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm mt-6" data-testid="invoice-settings">
      <h2 className="text-lg font-semibold text-slate-900 flex items-center gap-2"><Receipt className="w-5 h-5 text-blue-600" />Invoice details</h2>
      <p className="text-sm text-slate-500 mb-4">Shown as the seller on every invoice page and invoice PDF. Leave business name, email or website blank to use the ShopAdvisor™ defaults.</p>
      <div className="grid sm:grid-cols-2 gap-3">
        {FIELDS.map(([k, l]) => <div key={k} className={k === "address" ? "sm:col-span-2" : ""}><Label className="text-xs">{l}</Label><Input value={f[k] || ""} onChange={e => setF({ ...f, [k]: e.target.value })} data-testid={`invoice-settings-${k}`} /></div>)}
      </div>
      <button onClick={save} className="mt-4 bg-slate-900 hover:bg-slate-700 text-white text-sm font-bold px-4 py-2 rounded-lg flex items-center gap-1.5" data-testid="invoice-settings-save"><Save className="w-4 h-4" />Save</button>
    </div>
  );
};
